module.exports = __webpack_public_path__ + "static/media/car-gray-only.78445e11.svg";